/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './apgar-score.reducer';

export const ApgarScoreDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const apgarScoreEntity = useAppSelector(state => state.apgarScore.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="apgarScoreDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.apgarScore.detail.title">ApgarScore</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.apgarScore.id">Id</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.id}</dd>
          <dt>
            <span id="appearance">
              <Translate contentKey="tinyMedicRestApp.apgarScore.appearance">Appearance</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.appearance}</dd>
          <dt>
            <span id="pulse">
              <Translate contentKey="tinyMedicRestApp.apgarScore.pulse">Pulse</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.pulse}</dd>
          <dt>
            <span id="grimace">
              <Translate contentKey="tinyMedicRestApp.apgarScore.grimace">Grimace</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.grimace}</dd>
          <dt>
            <span id="activity">
              <Translate contentKey="tinyMedicRestApp.apgarScore.activity">Activity</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.activity}</dd>
          <dt>
            <span id="respiration">
              <Translate contentKey="tinyMedicRestApp.apgarScore.respiration">Respiration</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.respiration}</dd>
          <dt>
            <span id="frequency">
              <Translate contentKey="tinyMedicRestApp.apgarScore.frequency">Frequency</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.frequency}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.apgarScore.active">Active</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.apgarScore.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.apgarScore.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.apgarScore.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.apgarScore.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{apgarScoreEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.apgarScore.birthHistory">Birth History</Translate>
          </dt>
          <dd>{apgarScoreEntity.birthHistory ? apgarScoreEntity.birthHistory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.apgarScore.recordedBy">Recorded By</Translate>
          </dt>
          <dd>{apgarScoreEntity.recordedBy ? apgarScoreEntity.recordedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.apgarScore.recordedAt">Recorded At</Translate>
          </dt>
          <dd>{apgarScoreEntity.recordedAt ? apgarScoreEntity.recordedAt.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/apgar-score" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/apgar-score/${apgarScoreEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ApgarScoreDetail;
